.textAreaStyle {
    font-size: 14px;
    background: var(--mantine-color-dark-5);
    border: 1px solid var(--mantine-color-dark-3);
}

.linkButton {
    &[data-variant="transparent"] {
        &:hover {
            background-color: transparent;
            color: var(--mantine-color-dark-3);
        }
    }
    color: var(--mantine-color-dark-2);
}

.styledInput {
    border-radius: var(--mantine-radius-sm);
    border: 1px solid var(--mantine-color-dark-3);
    background: var(--mantine-color-dark-5);
}

.orderNumberText {
    font-weight: var(--mantine-font-weight-heavy);
    margin-bottom: 4px;
}
.descriptionText {
    color: var(--mantine-color-gray-1);
    font-weight: 700;
    line-height: 1.5rem;
}
.select {
    background-color: var(--mantine-color-dark-8);
}
